<template>
  <div>
    <div class="card">
      <div class="card-content pl-4 pr-4">
        <v-row class="pa-4" justify="space-between">
          <legend>Bajas Programadas</legend>
        </v-row>
        <v-row class="pa-4 mt-0" justify="space-between">
          <v-col cols="6">
            <v-autocomplete v-if="getKey('permisos').includes(17)"
                            v-model="dependencia"
                            :items="dependencias"
                            :filter="filterAutocomplete"
                            placeholder="Seleccione una dependencia"
                            :menu-props="{ auto: true, overflowY: true, closeOnClick: true }"
                            item-text="valor"
                            item-value="id"
                            clearable
                            hide-details
                            single-line
                            class=" p-0 m-0 ml-3"
                            @change="getBajas"></v-autocomplete>
          </v-col>
          <v-col class="text-right m-0" tag="strong" cols="3">
            <v-select
                      v-model="periodo"
                      :items="periodos"
                      placeholder="Seleccione un periodo"
                      item-text="year"
                      item-value="year"
                      clearable
                      hide-details
                      single-line
                      class=" p-0 m-0 ml-3"
                      @change="getBajas"></v-select>
          </v-col>
          <v-col class="text-right m-0" tag="strong" cols="3">
            <v-select
                      v-model="estatus"
                      :items="estatusList"
                      placeholder="Seleccione un estatus"
                      item-text="text"
                      item-value="value"
                      clearable
                      hide-details
                      single-line
                      class=" p-0 m-0 ml-3"
                      @change="getBajas"></v-select>
          </v-col>
        </v-row>

        <v-row class="pa-4 mt-0" justify="space-between">

          <v-col class="d-flex text-center">
            <v-scroll-y-transition mode="out-in">
              <v-card class="pt-0 mx-auto" flat outlined width="100%">
                <v-row class="text-left m-0 p-0" tag="v-card-text">
                  <v-col class="text-right m-0" cols="12">
                    <v-spacer></v-spacer>
                    <v-btn outlined color="success" :loading="loading_excel" @click.prevent="download" :disabled="bajasList.length == 0">
                      <i class="fa fa-file-excel mr-2"></i> Registros
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row class="text-left m-0 p-0" tag="v-card-text">
                  <v-col>
                    <!--  @update:options="getBajas" -->
                    <v-data-table
                                  :headers="headers"
                                  :items="bajasList"
                                  :footer-props="listSize"
                                  :options.sync="pagination"
                                  :server-items-length="totalItems"
                                  :loading="isLoading"
                                  :fixed-header="true"
                                  item-key="id"
                                  class="elevation-0 rounded-0 border-top"
                                  @update:options="getBajas">

                      <template v-slot:item.acciones="{ item }">
                        <div class="d-flex justify-content-center">
                          <b-button @click.prevent="read(item)" class="btn-s edit mr-2" variant="success">
                            <i class="fas fa-ellipsis-h"></i></b-button>
                          <br>
                        </div>
                      </template>
                      <template v-slot:item.info="{ item }">
                        <div class="text-left">
                          {{ getInfo(item.declarante) }}
                        </div>
                      </template>
                      <template v-slot:item.dependencia="{ item }">
                        <div class="text-left">
                          {{ item || {}.encargo || {}.ente_publico_id ? filterCatalog(item.encargo.ente_publico_id, dependencias) : '' }}
                        </div>
                      </template>
                      <template v-slot:item.estatus="{ item }">
                        <div class="text-left">
                          <v-chip :color="item.estatus ? 'green' : 'blue-grey '" text-color="white" label>
                            {{ item.estatus ? 'Procesada' : 'Pendiente' }}
                          </v-chip>
                        </div>
                      </template>
                    </v-data-table>

                  </v-col>
                </v-row>
              </v-card>
            </v-scroll-y-transition>
          </v-col>

        </v-row>
      </div>
    </div>
    <v-dialog v-model="dialog" scrollable max-width="600">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Informe de registro
        </v-card-title>

        <v-card-text>
          <v-timeline
                      align-top
                      dense>
            <v-timeline-item
                             v-for="(item, i) in dialogData"
                             :key="i"
                             small>
              <div>
                <div class="font-weight-normal">
                  <strong>{{ i }}</strong>
                </div>
                <div>{{ item }} </div>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
                 color="primary"
                 text
                 @click="dialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  components: {

  },
  data () {
    return {
      active: [],
      loading_excel: false,
      dialog: false,
      estatus: null,
      estatusList: [{
        text: 'Procesada',
        value: true

      }, {
        text: 'Pendiente',
        value: false

      }],
      isLoading: false,
      dialogData: {},
      periodo: {},
      dependencia: null,
      dependenciaActual: null,
      bajasList: [],
      headers: [
        // {
        //   text: 'Acciones',
        //   value: 'acciones',
        //   align: 'center',
        //   sortable: false,
        //   width: '80'

        // },
        {
          text: 'Nombre completo',
          value: 'info',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Dependencia',
          value: 'dependencia',
          sortable: false,
          align: 'center'
        },
        // {
        //   text: 'Datos encargo',
        //   value: 'datos_encargo_actual_id',
        //   align: 'center'
        // },
        {
          text: 'Tipo de baja',
          value: 'tipo_baja',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Fecha de baja',
          value: 'fecha_baja',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Estatus',
          value: 'estatus',
          sortable: false,
          align: 'center'
        }
      ],
      dataExcelRegistro: [],
      meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ],
      campos_excel: {},
      file_name: '',
      totalItems: 0,
      listSize: {
        itemsPerPageOptions: [10, 25, 50, 100],
        showFirstLastPage: true
      },
      pagination: {
        page: 1,
        itemsPerPage: 10
      }
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  computed: {},
  methods: {
    getInfo (item) {
      const nombre = item.nombres
      const primer_apellido = item.primer_apellido
      const segundo_apellido = item.segundo_apellido

      return [nombre, primer_apellido, segundo_apellido].filter(element => element).join(' ')
    },
    read (item) {
      this.dialog = true
      this.dialogData = item
    },
    getSlotName (slot) {
      return 'item.' + slot
    },
    formatMax (value) {
      console.log(value)
      if (value) {
        let len = 100
        return value.substr(0, len) + (value.length > len ? '...' : '')
      }
      return ' '
    },
    checkPermissions () {
      let permiso = [29]
      if (!this.getKey('permisos').some(r => permiso.includes(r))) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    async getBajas (e) {
      var sort = {}
      if (e) {
        sort.sortBy = e.sortBy
        sort.sortDesc = e.sortDesc
      }

      this.isLoading = true

      var page = this.pagination.page

      if (this.dependencia !== this.dependenciaActual) {
        this.pagination.page = page = 1
        this.dependenciaActual = this.dependencia
      }

      var params = {
        params: {
          page: page,
          itemsPerPage: this.pagination.itemsPerPage,
          filters: {
            dependencia: this.dependencia,
            periodo: this.periodo,
            estatus: this.estatus
          },
          sort: sort
        }
      }

      this.$http.get('baja_anticipada', params).then(
        response => {
          const bajas = response.data

          this.bajasList = [...bajas.data]

          this.totalItems = Number(bajas.total)
          this.pagination.page = Number(bajas.current_page)

          this.isLoading = false
        },
        error => {
          this.isLoading = false
          this.StepError(error)
        }
      )
    },
    // download () {
    //   this.loading_excel = true
    //   this.$http.get('bajas/export/' + this.log, { responseType: 'arraybuffer' }).then(
    //     response => {
    //       let blob = new Blob([response.data], { type: 'application/octet-stream' })
    //       //   console.log(blob);
    //       let link = document.createElement('a')
    //       link.href = window.URL.createObjectURL(blob)
    //       link.download = this.log
    //       link.click()

    //       this.loading_excel = false
    //     },
    //     error => {
    //       this.loading_excel = false
    //       this.StepError(error)
    //     }
    //   )
    // },
    download () {
      var params = {
        filters: {
          dependencia: this.dependencia,
          periodo: this.periodo,
          estatus: this.estatus
        }
      }

      this.loading_excel = true
      // Se genera un blob para descargar el archivo
      this.$http.get('bajas/export/', { params, responseType: 'arraybuffer' }).then(
        response => {
          // let blob = new Blob([response.data], { type: "application/xlsx" });
          let blob = new Blob([response.data])
          //   console.log(blob);
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)

          let name = 'bajas-anticipadas'

          link.download = `${name}-${moment().format('DD-MM-YYYY')}.xlsx`
          link.click()
          this.loading_excel = false
        },
        error => {
          this.loading_excel = false
          this.StepError(error)
        }
      )
    }

  },
  created () {
    this.dependencia = this.getKey('ente_publico_id')
    this.getBajas()
    this.checkPermissions()
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>
<style>
.v-text-field.v-text-field--solo .v-input__control input {
  border: none !important;
}

.v-label.theme--dark {
  color: #fff !important;
}

.theme--light.v-divider {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/BajasProgramadas.vue